export interface StatisticState {
  telegramOtpStatisticDetail: DetailItem[];
  telegramOtpStatisticGroup: TelegramOtpGroupItem[];
  telegramOtpGroupings: {
    telegramOtpGroup: string[];
    telegramOtpGroupOptionally: string[];
  };
};

export interface DetailItem {
  id: string;
  create_date: string;
  originator: string;
  recipient: string;
  partner: string;
  service_provider?: string;
  status: string,
  error_code: number,
};

export class TelegramOtpDetailItemInfo {
  id: string = '';
  create_date: string = '';
  sent_date?: string;
  delivery_date?: string;
  read_date?: string;
  expire_date?: string;
  external_id?: string;
  service_provider?: string;
  originator: string = '';
  recipient: string = '';
  recipient_country?: string;
  parent_message_id?: string;
  parent_message_channel?: string;
  partner: string = '';
  partner_user_login?: string;
  status: string = '';
  error_code?: number;
  error_description?: string;
  message_type?: string;
  priority?: number;
  partner_price?: string;
  provider_price?: string;
  broker_account_login?: string;
  recipient_region?: string;
  template_id?: string;
  connection_type?: string;
  ext_id1?: string;
  ext_id2?: string;
  ext_id3?: string;
  ext_id4?: string;
  ext_id5?: string;
};

export class DetailFilterParams {
  message_direction:string = 'mt';
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  service_provider?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  flag?: string|null = undefined;
  sent_date_from?: string = undefined;
  sent_date_to?: string = undefined;
  deliver_date_from?: string = undefined;
  deliver_date_to?: string = undefined;
  template_id?: number = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  external_id?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
};

export interface TelegramOtpGroupItem {
  date?: string;
  originator?: string;
  service_provider?: string;
  partner?: string;
  template_id?: string;
  delivered: number;
  read: number;
  not_delivered: number;
  transmitted: number;
  expired: number;
  failed: number;
  rejected: number;
  deferred: number;
  total: number;
  partner_price: string;
  provider_price: string;
};

export class GroupFilterParams {
  message_direction: string = 'mt';
  date_from: string;
  date_to: string;
  group_by: string;
  template_id?: number = undefined;
  message_type?: string|null = undefined

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
  }
};
